import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmNotificationDetailModel } from "../../services/alarm-data-service/Models";
import AlarmDataService from "../../services/alarm-data-service/AlarmDataService";

export type UseAlarmNotificationDetailParams = {
    organizationID: number,
    contextGroupID: number,
    //queryParams: IQueryAlarmNotificationParams
    startDate: Date,
    endDate: Date
} & BaseUseQueryParameters<IAlarmNotificationDetailModel[] | undefined>;

export function useAlarmNotificationDetail({
    organizationID,    
    contextGroupID,
    startDate,
    endDate,
    enabled,    
    onSuccess,
    onError
}: UseAlarmNotificationDetailParams) {
    return useQuery<IAlarmNotificationDetailModel[], RestError>(
        keys.alarmNotificationDetail(organizationID, contextGroupID, startDate, endDate),
        ({ signal }) => {
            return AlarmDataService.queryAlarmNotificationDetail(
                organizationID,
                contextGroupID,
                //queryParams,
                startDate,
                endDate,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            staleTime: Infinity

        }
    );
}